var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isUserGranted ? _c('v-sheet', [_c('v-tabs', {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_vm._l(_vm.tabs, function (tab) {
    return [_c('v-tab', {
      key: tab.value
    }, [_vm._v(" " + _vm._s(tab.text) + " ")])];
  })], 2), _c('v-divider', {
    staticClass: "mb-24 mb-lg-48"
  }), _c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_vm._l(_vm.tabs, function (item, index) {
    return [_c('v-tab-item', {
      key: item.value
    }, [_c("body-".concat(item.value.toLowerCase()), _vm._b({
      tag: "component"
    }, 'component', {
      isTabActive: _vm.tab == index
    }, false))], 1)];
  })], 2)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }